import React from "react";

export default function CasinoMeterRules() {
  return (
    <div className="modal-body">
      <div>
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html:
              '\n        .rules-section .row.row5 {\n            margin-left: -5px;\n            margin-right: -5px;\n        }\n        .rules-section .pl-2 {\n            padding-left: .5rem !important;\n        }\n        .rules-section .pr-2 {\n            padding-right: .5rem !important;\n        }\n        .rules-section .row.row5 > [class*="col-"], .rules-section .row.row5 > [class*="col"] {\n            padding-left: 5px;\n            padding-right: 5px;\n        }\n        .rules-section\n        {\n            text-align: left;\n            margin-bottom: 10px;\n        }\n        .rules-section .table\n        {\n            color: #fff;\n            border:1px solid #444;\n            background-color: #222;\n            font-size: 12px;\n        }\n        .rules-section .table td, .rules-section .table th\n        {\n            border-bottom: 1px solid #444;\n        }\n        .rules-section ul li, .rules-section p\n        {\n            margin-bottom: 5px;\n        }\n        .rules-section::-webkit-scrollbar {\n            width: 8px;\n        }\n        .rules-section::-webkit-scrollbar-track {\n            background: #666666;\n        }\n\n        .rules-section::-webkit-scrollbar-thumb {\n            background-color: #333333;\n        }\n        .rules-section .rules-highlight\n        {\n            color: #FDCF13;\n            font-size: 16px;\n        }\n        .rules-section .rules-sub-highlight {\n            color: #FDCF13;\n            font-size: 14px;\n        }\n        .rules-section .list-style, .rules-section .list-style li\n        {\n            list-style: disc;\n        }\n        .rules-section .rule-card\n        {\n            height: 20px;\n            margin-left: 5px;\n        }\n        .rules-section .card-character\n        {\n            font-family: Card Characters;\n        }\n        .rules-section .red-card\n        {\n            color: red;\n        }\n        .rules-section .black-card\n        {\n            color: black;\n        }\n        .rules-section .cards-box\n        {\n            background: #fff;\n            padding: 6px;\n            display: inline-block;\n            color: #000;\n            min-width: 150px;\n        }\n    ',
          }}
        />
        <div className="rules-section">
          <div>
            <img
              src="https://sitethemedata.com/v3/static/front/img/casino-rules/cmeter.png"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
      <div>
        <div className="rules-section">
          <h6 className="rules-highlight">Low Zone:</h6>
          <ul className="pl-4 pr-4 list-style">
            <li>
              The Player who bet on Low Zone will have all cards from Ace to 8
              of all suits 3 cards of 9, Heart , Club &amp; Diamond.
            </li>
          </ul>
          <h6 className="rules-highlight">High Zone:</h6>
          <ul className="pl-4 pr-4 list-style">
            <li>
              The Player who bet on high Zone will have all the cards of JQK
              of all suits plus 3 cards of 10, Heart, Club &amp; Diamond.
            </li>
          </ul>
          <h6 className="rules-highlight">Spade 9 &amp; Spade 10:</h6>
          <ul className="pl-4 pr-4 list-style">
            <li>
              If you Bet on Low Card, Spade of 9 &amp; 10 will calculated
              along with High Cards.
            </li>
            <li>
              If you Bet on High Card, Spade of 9 &amp; 10 will calculated
              along with Low Cards.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
